import axios from "axios";

export interface Service<T> {
  get: (id: number) => Promise<T>;
  getAll: () => Promise<T[]>;
  add: (data: T) => Promise<T>;
  update: (data: T) => Promise<T>;
  delete: (id: number) => Promise<void>;
}

export class GenericService<T> implements Service<T> {
  public baseUrl: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  getAll = async (): Promise<T[]> => {
    const result = await axios.get<T[]>(this.baseUrl);
    return result.data;
  };

  add = async (entity: T) => {
    const result = await axios.post<T>(this.baseUrl, entity);
    return result.data;
  };

  update = async (entity: T) => {
    const result = await axios.put<T>(`${this.baseUrl}`, entity);
    return result.data;
  };

  get = async (id: number) => {
    const result = await axios.get<T>(`${this.baseUrl}/${id}`);
    return result.data;
  };

  delete = async (id: number) => {
    await axios.delete(`${this.baseUrl}/${id}`);
  };
}
